import { jsx, jsxs } from "react/jsx-runtime";
import { Tabs } from "@zillow/constellation";
import { triggerTabClickEvent, CustomPropTypes } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import React, { useRef, useState, useEffect } from "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
function getTabFromHash(innerBlocks) {
  if (typeof window === "undefined") return void 0;
  const hash = window.location.hash.slice(1);
  if (!hash) return void 0;
  const matchingBlock = innerBlocks.find((block) => block.attrs.id === hash);
  return matchingBlock == null ? void 0 : matchingBlock.attrs;
}
function updateUrlHash(id) {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  url.hash = id;
  window.history.replaceState(null, "", url.toString());
}
const HtmlToReact = require("html-to-react");
const HtmlToReactParser = require("html-to-react").Parser;
const htmlToReactParser = new HtmlToReactParser();
const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
const processingInstructions = [{
  shouldProcessNode() {
    return true;
  },
  processNode: processNodeDefinitions.processDefaultNode
}];
const TabsBlock = ({
  attrs,
  index,
  innerBlocks
}) => {
  const containerRef = useRef(null);
  const tabs = [];
  const panels = [];
  innerBlocks.forEach((innerBlock) => {
    const {
      tabId
    } = innerBlock.attrs;
    tabs.push(/* @__PURE__ */ jsx(Tabs.Tab, { id: tabId, children: htmlToReactParser.parseWithInstructions(innerBlock.attrs.label, () => true, processingInstructions) }, tabId));
    panels.push(/* @__PURE__ */ jsx(Tabs.Panel, { "aria-labelledby": tabId, id: innerBlock.attrs.id, children: generateBlockList({
      blocks: innerBlock.innerBlocks
    }) }, tabId));
  });
  const initialTabId = attrs.defaultSelectedId || innerBlocks[0].attrs.tabId;
  const [selectedTabId, setSelectedTabId] = useState(initialTabId);
  useEffect(() => {
    const hashTab = getTabFromHash(innerBlocks);
    if (hashTab) {
      setSelectedTabId(hashTab.tabId);
      requestAnimationFrame(() => {
        var _a;
        (_a = containerRef.current) == null ? void 0 : _a.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    }
  }, []);
  return /* @__PURE__ */ jsx("div", { ref: containerRef, children: /* @__PURE__ */ jsxs(Tabs, { appearance: attrs.appearance, selected: selectedTabId, onSelected: (tabId) => {
    setSelectedTabId(tabId);
    const tabInnerBlock = innerBlocks.find((innerBlock) => innerBlock.attrs.tabId === tabId);
    if (!tabInnerBlock) {
      throw new Error(`Could not find tab for tabId of "${tabId}"`);
    }
    updateUrlHash(tabInnerBlock.attrs.id);
    triggerTabClickEvent({
      id: tabInnerBlock.attrs.id,
      label: tabInnerBlock.attrs.label
    });
  }, id: attrs.id, children: [
    /* @__PURE__ */ jsx(Tabs.List, { fluid: remapFluidTokensForConstellationV8(attrs.fluid), justifyContent: attrs.justifyContent, children: tabs }),
    /* @__PURE__ */ jsx(Tabs.Panels, { children: panels })
  ] }, index) });
};
TabsBlock.propTypes = {
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({
    attrs: PropTypes.shape({
      tabId: PropTypes.string.isRequired,
      id: PropTypes.string,
      label: PropTypes.string
    })
  })),
  attrs: PropTypes.shape({
    appearance: PropTypes.string.isRequired,
    defaultSelectedId: PropTypes.string,
    fluid: PropTypes.shape({
      default: PropTypes.bool,
      lg_lte: PropTypes.bool,
      sm_lte: PropTypes.bool
    }).isRequired,
    justifyContent: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(["center", "flex-start", "flex-end"]))
  }),
  index: PropTypes.number
};
function remapFluidTokensForConstellationV8(fluidValue) {
  if (typeof fluidValue !== "object" || fluidValue === null) {
    return fluidValue;
  }
  const remapped = {};
  if ("sm_lte" in fluidValue) {
    remapped.sm_lte = !!fluidValue.sm_lte;
  }
  if ("lg_lte" in fluidValue) {
    remapped.md_gte = !!fluidValue.lg_lte;
  }
  if ("default" in fluidValue) {
    remapped.xl_gte = !!fluidValue.default;
  }
  return remapped;
}
export {
  TabsBlock as default,
  remapFluidTokensForConstellationV8
};
